import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
  TemplateRef,
  OnDestroy,
  AfterViewInit,
  Input,
  OnChanges,
  SimpleChanges,
  forwardRef,
} from "@angular/core";
import { Subject, fromEvent } from "rxjs";
import _ from "lodash";
import { NzModalService } from "ng-zorro-antd/modal";
import { TranslateService } from "@root/shared/service/translate.service";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { HttpClient } from "@angular/common/http";
enum type {
  group = "group",
  houseType = "houseType",
}

type SelectType = 'group' | 'type';

interface Option {
  label: string;
  value: any;
}
interface Item {
  id?: number;
  list?: number[];
  type: SelectType;
}

type Value = [SelectType, number[], any[]?];

export const GROUP_TYPE_SWITCH_PICKER_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => GroupTypeSwitchPickerComponent),
  multi: true
};

/** @deprecated 代码质量太次，废弃 */
@Component({
  selector: "host-group-type-switch-picker",
  templateUrl: "./group-type-switch-picker.component.html",
  styleUrls: ["./group-type-switch-picker.component.scss"],
  providers: [ GROUP_TYPE_SWITCH_PICKER_VALUE_ACCESSOR  ]
})
export class GroupTypeSwitchPickerComponent
  implements OnInit, AfterViewInit, OnDestroy, OnChanges, ControlValueAccessor {
    _clear = false;
  @Input() bordered = false;
  @Input() showWidth = null;
  @Input() defaultValue = null;
  @Input()
  get clear () {
    return this._clear;
  };
  set clear (value) {
    this._clear = value;
    if (this._clear) {
      this.onReset();
    }
  }
  @Input() borderRadius = "4px";
  /** TODO: 命名不规范，修改 */
  @Output('checkedGroupChange') checkedGroupChange = new EventEmitter<Item>();
  @Output() onSelect = new EventEmitter<Item>(); // 用于替代上一行不规范的代码
//----------------------------以上字段全废弃----------------------------------
  @Input() borderless = true;
  groupList = [];
  typeList = [];

  isOpen = false;

  selectType: SelectType = 'group';
  // @deprecated
  result = {
    type: this.selectType,
    ids: [],
    list: []
  };
  value: Value = ['group', []]; // @deprecated
  inputTextView;
  type: SelectType = 'group';
  selected: Set<any> = new Set();
  // selectList = new Set<number>();
  private destroy$ = new Subject();

  get listOfPanelItem () {
    return this.type === 'group' ? this.groupList : this.typeList;
  }
  _registerOnChange: (value: any) => void = (v: any) => {};
  // get inputTextView() {
  //   if (this.result.list.length > 1) {
  //     return '共' + this.result.list.length + (this.selectType === 'group' ? '组' : '房型')
  //   } else if (this.result.list.length === 1) {
  //     const item = this.result.list[0];
  //     return item['_name'];
  //   } else {
  //     return null;
  //   }
  // }

  constructor(
    private modalService: NzModalService,
    private http: HttpClient,
    private t: TranslateService
  ) {}
  writeValue(obj: Value): void {
    console.log('write value obj: ', obj);

    this.value = obj ?? ['group', []];
    if (obj) {
      this.type = obj[0];
      this.selected = new Set(obj[1] ?? []);
    } else {
      this.type = 'group';
      this.selected = new Set();
    }
    console.log('selected: ', this.selected);

    this.updateInputTextView();
  }
  registerOnChange(fn: any): void {
    this._registerOnChange = fn;
  }
  registerOnTouched(fn: any): void {
  }
  setDisabledState?(isDisabled: boolean): void {
  }

  ngOnInit() {
    this.fetchGroupList();
    this.fetchTypeList();
  }

  ngAfterViewInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  // private toggleListCheckStatus (list, status) {
  //   _.forEach(list, item => { item.checked = status });
  // }

  // private markSpecifiedItemsAsChecked (list: Array<any>, ids: Array<number> = []) {
  //   const items = list.filter(item => ids.indexOf(item._id) !== -1);
  //   this.toggleListCheckStatus(items, true);
  // }

  private fetchGroupList () {
    this.http.get('/api/house_group/group_list').subscribe((res: any) => {
      const list = res?.data?.list ?? [];
      this.groupList = list.map(item => ({
        label: item.name,
        value: item.group_id
      }));

      this.updateInputTextView();
      // this.groupList = _.map(list, g => ({ ...g, _id: g.group_id, _name: g.name }));

      // if (this.defaultValue && this.defaultValue.type === 'group') {
      //   this.selectType = 'group';
      //   this.markSpecifiedItemsAsChecked(this.groupList, this.defaultValue.ids);
      // }

      // this.collectSelectResult();
    });
  }

  private fetchTypeList () {
    this.http.get('/api/house_type/all').subscribe((res: any) => {
      const list = res?.data?.list ?? [];
      this.typeList = list.map(item => ({
        label: item.title,
        value: item.id
      }));
      this.updateInputTextView();
      // this.typeList = _.map(list, t => ({ ...t, _id: t.id, _name: t.title}));
      // if (this.defaultValue && this.defaultValue.type === 'type') {
      //   this.selectType = 'type';
      //   this.markSpecifiedItemsAsChecked(this.typeList, this.defaultValue.ids);
      // }

      // this.collectSelectResult();

    });
  }

  onCancel () {
    // if (this.defaultValue) {
    //   this.toggleListCheckStatus(this.groupList, false);
    //   this.toggleListCheckStatus(this.typeList, false);

    //   if (this.defaultValue.type === 'group') {
    //     this.markSpecifiedItemsAsChecked(this.groupList, this.defaultValue.ids);
    //   } else if (this.defaultValue.type === 'type') {
    //     this.markSpecifiedItemsAsChecked(this.typeList, this.defaultValue.ids);
    //   }
    // }
    this.closeDropdown();
    // this.toggleListCheckStatus(this.);
  }

  onSave () {
    this.compatRubbishCode(); // @deprecated
    this.updateInputTextView();

    const value = [this.type, Array.from(this.selected)];
    this._registerOnChange(value);
    this.closeDropdown();

    // this.updateInputTextView();
  }

  onReset () {
    // this.toggleListCheckStatus(this.groupList, false);
    // this.toggleListCheckStatus(this.typeList, false);

    this.type = 'group';
    this.selected.clear();
    // this.compatRubbishCode();

    // this.closeDropdown();
  }

  onItemSelect (item: any) {
    // const list: Set<number> = this.selectList;
    // console.log('item: ', item);
    // const id = this.selectType === 'group' ? item.group_id : item.id;

    // if (list.has(id)) {
    //   list.delete(id);
    //   item.checked = false;
    // } else {
    //   list.add(id);
    //   item.checked = true;
    // }
    // item.checked = !item.checked;

    // new
    if (this.selected.has(item.value)) {
      this.selected.delete(item.value);
    } else {
      this.selected.add(item.value);
    }
  }

  onTypeChange (type: SelectType) {
    // this.selectType = type;

    // if (this.selectType === 'group') {
    //   this.toggleListCheckStatus(this.typeList, false);
    // } else {
    //   this.toggleListCheckStatus(this.groupList, false)
    // }

    // new

    this.type = type;
    this.selected = new Set();
  }

  private compatRubbishCode () {
    const list = this.listOfPanelItem.filter(item => this.selected.has(item.value));
    this.result = { // @deprecated
      type: this.type,
      ids: Array.from(this.selected),
      list
    };
    this.checkedGroupChange.emit(this.result); // @deprecated
    this.onSelect.emit(this.result); // @deprecated
  }

  private updateInputTextView () {
    if (this.selected.size > 1) {
      this.inputTextView = this.t.syncGet('component.cleaner_assign_picker.textview', { number: this.selected.size });
      // this.inputTextView = '共' + this.result.list.length + (this.selectType === 'group' ? '组' : '房型')
    } else if (this.selected.size === 1) {
      const id = Array.from(this.selected)[0];
      const item = this.listOfPanelItem.find(item => item.value === id);
      this.inputTextView = item?.label;
    } else {
      this.inputTextView = null;
    }
  }

  private closeDropdown () {
    this.isOpen = false;
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
